import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import { Box, IconButton } from '@mui/material';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import { useColorScheme } from '@mui/material/styles';
import NotificationBell from './NotificationBell';
import IntegrationHealthIndicator from './IntegrationHealthIndicator';

const CustomToolbarActions = forwardRef(({ isAuthenticated = false, enableThirdPartyIntegration = false }, ref) => {
    const { mode, setMode } = useColorScheme();
    const notificationBellRef = useRef();
    const integrationHealthRef = useRef();

    const toggleColorScheme = () => {
        setMode(mode === 'dark' ? 'light' : 'dark');
    };

    useImperativeHandle(ref, () => ({
        refreshNotifications: () => {
            if (notificationBellRef.current) {
                notificationBellRef.current.refreshNotifications();
            }
            if (integrationHealthRef.current) {
                integrationHealthRef.current.refresh();
            }
        }
    }));

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {isAuthenticated && enableThirdPartyIntegration && (
                <IntegrationHealthIndicator ref={integrationHealthRef} />
            )}
            {isAuthenticated && <NotificationBell ref={notificationBellRef} />}
            <IconButton
                color="inherit"
                onClick={toggleColorScheme}
                title={`Switch to ${mode === 'dark' ? 'light' : 'dark'} mode`}
            >
                {mode === 'dark' ? <LightModeIcon /> : <DarkModeIcon />}
            </IconButton>
        </Box>
    );
});

CustomToolbarActions.displayName = 'CustomToolbarActions';

export default CustomToolbarActions; 